/**
 * 📄 Model that represents a specific stop-loss
 */
export default class StopLossModel {
  constructor(
    public stop: number,
    public trailing: boolean,
    public startingPortfolio?: number,
    public highestPortfolio?: number
  ) {}
}
